import React, { useState, useEffect } from 'react';
import { Grid, Typography, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { keyframes } from '@emotion/react';
import { formatLocalDateTime } from '../../utils/dateTime';

export default function NotificationPopup (props){
    const [showNotification, setShowNotification] = useState(false);
    const [newAlert, setNewAlert] = useState({})
    const navigate = useNavigate();

    const zoomInOut = keyframes`
      0% {
        transform: scale(0.5);
        opacity: 0;
      }
      100% {
        transform: scale(1);
        opacity: 1;
      }
    `;

    const zoomOut = keyframes`
      0% {
        transform: scale(1);
        opacity: 1;
      }
      100% {
        transform: scale(0.5);
        opacity: 0;
      }
    `;

    useEffect(() => {
        // Show notification for 10 seconds
        setShowNotification(props.show);
        setNewAlert(props.alert);
        setTimeout(() => {
        setShowNotification(false);
        }, 10000); // Hide after 10 seconds
    }, [props]);

    const handleClick = () =>{
      navigate(`/alerts/${props.alert.Id}`);
    }

    return (
        showNotification && (
          <div onClick={handleClick} >
            <Grid justifyContent="flex-end" container sx={{
              position: 'fixed',
              bottom: '20px',
              right: '20px',
              zIndex: 1000,
            }}>
              <Paper
                sx={{
                  padding: 2,
                  backgroundColor: '#4caf50',
                  color: 'white',
                  borderRadius: 1,
                  width: '250px',
                  boxShadow: 3,
                  animation: `${zoomInOut} 0.3s ease-in-out`,
                  '&:exit': {
                    animation: `${zoomOut} 0.3s ease-in-out`,
                  },
                }}
              >
              <Grid item xs={12} md={12} lg={12}>
                <strong>New Alert!</strong>
              </Grid>
              <Grid item xs={12} md={12} lg={12}>
                <img
                  src={newAlert.Image ? `data:image/png;base64,${newAlert.Image}` : ""}
                  alt=""
                  style={{
                    width: '100%',
                    borderRadius: '8px',
                  }}
                />
              </Grid>
              <Grid item xs={12} md={12} lg={12}>
                <Typography>{newAlert.Description}</Typography>
              </Grid>
              <Grid item xs={12} md={12} lg={12}>
                <Typography>{newAlert.Reported_By}</Typography>
              </Grid>
              <Grid item xs={12} md={12} lg={12}>
                <Typography>{formatLocalDateTime(newAlert.CreatedAt)}</Typography>
              </Grid>
            </Paper>
          </Grid>
          </div>
        )
    );
};
